import { BlockContainer, ContentArea } from '@components';
import { styled } from '@mui/material';
import { palette, spacing } from '@themes/theme.helpers';
import React from 'react';

interface ContentBlockProps {
  title?: string;
  children?: React.ReactNode;
  content?: any;
  disableEditPanel?: boolean;
}

const Header = styled('header')`
  display: flex;
  font-weight: 600;
  font-size: ${spacing(3)};
  line-height: ${spacing(4)};
  color: ${palette.text('primary')};
`;

export const ContentBlock = ({ title, children, content = [] }: ContentBlockProps) => {
  const hasContent = content && content?.length > 0;
  return (
    <BlockContainer>
      <Header>{title}</Header>
      {children}
      {hasContent && <ContentArea content={content} />}
    </BlockContainer>
  );
};
